
const baseUrl = location.protocol+'//'+window.location.host ;
import axios from 'axios'
import { getToken, removeToken} from './auth'
import {router} from '@/router'
import qs from 'qs'
import { showLoadingToast,closeToast,showToast } from 'vant';
// import { JSONStringify } from 'lib/tool';
// import Vue from 'vue'
import { store } from '@/store'

const service = axios.create({
  baseURL: baseUrl,
  // withCredentials:true,
  timeout: 60000,
  headers:{
    'Content-Type':'application/json; charset=utf-8'
  }
  
})

service.defaults.headers.post['Content-Type']='application/x-www-form-urlencoded;charset=utf-8'

const pending = []
const CancelToken = axios.CancelToken
const removePending = (req) => {
  for (const p in pending) {
      let str = ''
      if(req.params){
        str = JSON.stringify(req.params)
      }
    if (pending[p].u === req.url + '&' + req.method +'&'+ str) {
      pending[p].f()
      pending.splice(p, 1)
    }
  }
}


service.interceptors.request.use(
  (req) => { 
   
    if(req.method=='get'){
      req.headers['Content-Type'] = 'application/json; charset=utf-8'
    }
    //  添加固定参数
    let token = getToken() || ''
    if(token) req.headers['Authorization'] =  `Bearer ${token}`
    req.params = {
      ...req.params,
     
    }
    removePending(req)
    req.cancelToken = new CancelToken((c) => {
      let str = ''
      if(req.params){
        str = JSON.stringify(req.params)
      }
      pending.push({ u: req.url + '&' + req.method +'&'+ str, f: c })
    })
    return req
  },
  (error) => {
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  (response) => {
    closeToast()
    removePending(response.config)
   
      if (response.data.code == 200 || response.data.code==0) {
        // 请求 success
        // localStorage.setItem('login',true)
        return Promise.resolve(response.data) 
      } else {
        if(response.data.code==401){
          //未登录
          removeToken()
          showToast('请登录')
          sessionStorage.setItem('back',router.currentRoute.value.fullPath)
          setTimeout(()=>{
            router.push("/login")
          },1000)
          return
        }
        // setIsPast(true)
        showToast(response.data.msg)
        
        return Promise.reject(new Error(response.data.msg || 'Error'))
      }
   
  },
  (error) => {
    console.log(error)
    // closeToast()
    if(error.code === 'ECONNABORTED' || error == 'timeout of 60000ms exceeded'){  
      showToast('系统繁忙，请稍后重试')
      
    }

    return Promise.reject(error)
  }
)
export default service
